import { render, staticRenderFns } from "./DrawerTabs.vue?vue&type=template&id=d4e13926&scoped=true"
import script from "./DrawerTabs.vue?vue&type=script&lang=js"
export * from "./DrawerTabs.vue?vue&type=script&lang=js"
import style0 from "./DrawerTabs.vue?vue&type=style&index=0&id=d4e13926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e13926",
  null
  
)

export default component.exports